import { OnlineStorage } from "@tblabs/storage";
import { Button, Span, TableBuilder } from "@tblabs/truffle";
import { Page } from "./Page";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { LogViewer } from "../Components/LogViewer";
import { AppState } from "../Services/AppState";
import { DatasetInfo } from "@tblabs/storage/Models/DatasetInfo";


export class DatabaseViewPage extends Page
{
    constructor(private _storage: OnlineStorage, private _appState: AppState, private db?: string)
    {
        super((db || _storage.DatabaseDir) + " database");

        this.Content(async () =>
        {
            if (this.db)
            {
                this._storage.SetDatabase(this.db);
            }

            this._appState.SetSubtitle(this._storage.DatabaseDir + " @ " + this._storage.Server);

            const datasets: DatasetInfo[] = await this._storage.ListDatasets();
            const users = await this._storage.ListUsers();

            this.body.Append(
                new Panel([new Span(this._storage.DatabaseDir).Bold(), " database"], ["At ", new Span(this._storage.Server).Bold(), " server"]),
                new Panel([new Span("Datasets").Bold(), ` (${datasets.length})`], [
                    new TableBuilder(datasets)
                        .AddColumn("Name", x => x.Name)
                        .AddColumn("Data", x => x.FilesCount + " " + (x.Metadata.Type?.toLowerCase() || "unknown") + (x.FilesCount != 1 ? "s" : "") + (!x.Metadata.Type ? " ⚠️" : ""))
                        .AddColumn("Options", x => [
                            new Button("OPEN").OnClick(() => window.location.hash = `admin/dataset/${x.Name}/view`),
                            new Button("EDIT META").MarginLeft(8).OnClick(() => window.location.hash = `admin/dataset/${x.Name}/metadata/edit`),
                        ])
                        .Build(),
                    new PrimaryButton("Add dataset").OnClick(() => window.location.hash = `admin/dataset/add`),
                ]),
                new Panel([new Span("Users").Bold(), ` (${users.length})`], [
                    new TableBuilder(users)
                        .AddColumn("Name", x => (x.Icon || "◯") + " " + x.Name)
                        .AddColumn("Role", x => x.Role)
                        .AddColumn("Options", x => new Button("OPEN").OnClick(() => window.location.hash = `admin/user/${x.Id}`))
                        .Build(),
                    new PrimaryButton("Add User").OnClick(() => window.location.hash = `admin/user/add`)
                ]),
                new Panel("Logs", [
                    new LogViewer(this._storage),
                ]),
            )
        });
    }
}
